import { useCreatePlaybookMutation } from "@qw/graphql";
import { PlaybookType } from "@qw/qw-common";
import { Button, Icon } from "@qw/ui";
import { useNavigate } from "react-router";

export const NewPlaybookButton = () => {
  const navigate = useNavigate();
  const [createPlaybook, { loading: creating }] = useCreatePlaybookMutation();

  const onCreate = async () => {
    const result = await createPlaybook({
      variables: {
        input: {
          name: "Untitled Playbook",
          description: "",
          workflow: "",
          type: PlaybookType.Workflow,
        },
      },
      refetchQueries: ["MyPlaybooks", "MyInvokablePlaybooks"],
    });
    const id = result.data?.createPlaybook?.id;
    if (id) {
      navigate(`/playbooks/${id}`);
    }
  };

  return (
    <Button variant="outline" size="sm" disabled={creating} onClick={onCreate}>
      <Icon icon="add" /> New
    </Button>
  );
};
